module.exports = __webpack_public_path__ + "static/media/logo2.6cb4b3d5.png";